import {
  TKwikUIInputCase,
  TKwikUIInputSize,
  TKwikUIInputType,
  VKwikUIInputCase,
  VKwikUIInputSize,
  VKwikUIInputType
} from "./input.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isString = (x: string) => typeof x === "string";

  const methods = {
    case: (x: TKwikUIInputCase) => VKwikUIInputCase.includes(x),
    disabled: isBoolean,
    focus: isBoolean,
    formControlName: isString,
    hintContent: isString,
    icon: isString,
    id: isString,
    invalid: isBoolean,
    isShowLabelOutside: isBoolean,
    label: isString,
    placeholder: isString,
    postfix: isString,
    prefix: isString,
    size: (x: TKwikUIInputSize) => VKwikUIInputSize.includes(x),
    type: (x: TKwikUIInputType) => VKwikUIInputType.includes(x)
  };

  return methods[key] && methods[key](value);
};
